import React from 'react';
import {
    PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend,
} from 'recharts';

const COLORS = ['#00d9ff', '#818cf8', '#2dd4bf', '#60a5fa', '#fbbf24', '#f472b6', '#a78bfa', '#34d399'];

const tooltipStyle = {
    contentStyle: {
        background: '#1e293b',
        border: '1px solid #334155',
        borderRadius: '8px',
        color: '#ffffff',
        fontSize: '13px',
        direction: 'rtl',
    },
};

const renderLegend = (props) => {
    const { payload } = props;
    return (
        <ul style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '10px 20px', padding: '12px 0 0', listStyle: 'none', direction: 'rtl' }}>
            {payload.map((entry, idx) => (
                <li key={idx} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, color: '#94a3b8' }}>
                    <span style={{ display: 'inline-block', width: 10, height: 10, borderRadius: '50%', background: entry.color, flexShrink: 0 }} />
                    {entry.value}
                </li>
            ))}
        </ul>
    );
};

export default function CategoryBreakdown({ data }) {
    if (!data?.length) return <p style={{ color: '#94a3b8', textAlign: 'center', padding: '60px 0' }}>لا توجد بيانات</p>;

    return (
        <ResponsiveContainer width="100%" height={320}>
            <PieChart>
                <Pie
                    data={data}
                    cx="50%"
                    cy="48%"
                    outerRadius={110}
                    innerRadius={40}
                    dataKey="count"
                    nameKey="name"
                    paddingAngle={2}
                >
                    {data.map((_, idx) => (
                        <Cell key={idx} fill={COLORS[idx % COLORS.length]} stroke="transparent" />
                    ))}
                </Pie>
                <Tooltip
                    {...tooltipStyle}
                    formatter={(v, n) => [v + ' احتجاج', n]}
                />
                <Legend content={renderLegend} />
            </PieChart>
        </ResponsiveContainer>
    );
}
